'use strict';

import css from '../css/button.css';
import utils from './utils';
import hproLog from './log';

var svgIcon = '\n\
    <svg class="bell" style="width:24px;height:24px" viewBox="0 0 24 24">\n\
        <path fill="#ffffff" d="M14,20A2,2 0 0,1 12,22A2,2 0 0,1 10,20H14M12,2A1,1 0 0,1 13,3V4.08C15.84,4.56 18,7.03 18,10V16L21,19H3L6,16V10C6,7.03 8.16,4.56 11,4.08V3A1,1 0 0,1 12,2Z" />\n\
    </svg>\n\
    <svg width="50" height="50">\n\
        <circle class="border-line" cx="165" cy="25" r="23" transform="rotate(-90, 95, 95)"></circle>\n\
    </svg>';

export default function buttonService(webPushService, customConfiguration) {
    var self = this;
    var defaultConfiguration = {
        theme: 'default',
        tooltip: {
            subscribe: 'Subscribe to notifications',
            unsubscribe: 'Unsubscribe from notifications'
        },
        dialog: {
            subscribe: 'Are you sure you want to subscribe to notifications?',
            unsubscribe: 'Are you sure you want to unsubscribe from notifications?'
        },
        notification: {
            subscribe: 'You are successfully subscribed to notifications',
            unsubscribe: 'You have unsubscribed from notifications',
            error: 'Subscribed to notifications failed'
        }
    }

    // merge configuration
    var buttonConfiguration = utils.merge(defaultConfiguration, customConfiguration);
   
    var subscribtionTooltipHTML = '<div id="hpro-webpush-tooltip">\n\
            <span>' + buttonConfiguration['tooltip']['subscribe'] + '</span>\n\
            <span>' + buttonConfiguration['tooltip']['unsubscribe'] + '</span>\n\
        </div>';
    var subscribtionNotificationHTML = '<div id="hpro-webpush-notification">\n\
            <div>\n\
                <span>' + buttonConfiguration['notification']['subscribe'] + '</span>\n\
                <span>' + buttonConfiguration['notification']['unsubscribe'] + '</span>\n\
                <span>' + buttonConfiguration['notification']['error'] + '</span>\n\
            </div>\n\
        </div>';

    var buttonElement = null;

    function setButtonPosition(newPosition) {
        if (!newPosition) return;

        //If position parameter is string
        // Examles: 'top-left', 'top-right', 'bottom-left', 'bottom-right'
        if (utils.isString(newPosition)) {
            var param = newPosition.split("-");
            // If splited string doesn't have 2 parameters
            // Invalid value
            if (param.length == 2) {
                for (var i in param) {
                    buttonElement.style[param[i]] = '30px';
                }
            }
        }
        //If position parameter is object
        else if (utils.isObject(newPosition)) {
            for (var i in conf['position']) {
                buttonElement.style[i] = conf['position'][i];
            }
        }

    };

    function createAndAppendButtonElement() {
        if (buttonElement) return;
        
        buttonElement = document.createElement('button');
        buttonElement.id = 'hpro-webpush-btn';
        buttonElement.className = '';
        buttonElement.innerHTML = svgIcon + subscribtionTooltipHTML + subscribtionNotificationHTML;
        buttonElement.dataset.percent = 0;
        buttonElement.dataset.theme = buttonConfiguration['theme'] || 'default';

        //Configuration hideAfterSubscribe param
        buttonElement.dataset.hide = buttonConfiguration['hideAfterSubscribe'] || '';

        buttonElement.addEventListener('click', subscriptionToggle);

        document.getElementsByTagName("body")[0].appendChild(buttonElement);

        setButtonPosition(buttonConfiguration['position']);
    };
    // Type: 'subscribe', 'unsubscribe', 'error'
    function setNotification(type){
        buttonElement.dataset.notification = type;
        buttonElement.dataset.fadein = 'true';
        setTimeout(function(){
            delete buttonElement.dataset.fadein;
            setTimeout(function(){
                delete buttonElement.dataset.notification;
             }, 500); 
         }, 3000); 

    }

    function resetButtonState() {
        buttonElement.disabled = true;
        buttonElement.dataset.percent = 0;
    };

    function setButtonState(isSubscribed) {
        buttonElement.disabled = false;
        buttonElement.className = '';
        if (isSubscribed) {
            buttonElement.className = 'subscribed';
            buttonElement.dataset.percent = 100;
        } else {
            buttonElement.className = 'unsubscribed';
        };
    };

    function validateButtonState() {
        createAndAppendButtonElement();
        
        resetButtonState();
        var p = webPushService.isSubscribed();
        hproLog('[validateButtonState] start');
        p.then(function () {
            hproLog('[validateButtonState] isSubscribed', true);
            setButtonState(true);
        }, function () {
            hproLog('[validateButtonState] isSubscribed', false);
            setButtonState(false);
        });
        return p;
    };

    function unsubscribe() {
        if (confirm(buttonConfiguration['dialog']['unsubscribe'])) {
            webPushService.unsubscribe().then(function () {
                setButtonState(false);
                setNotification('unsubscribe');
            }, function () {
                setButtonState(true);
                setNotification('error');
            });
        }
    }

    function subscribe() {
        if (confirm(buttonConfiguration['dialog']['subscribe'])) {
            webPushService.subscribe().then(function () {
                setButtonState(true);
                setNotification('subscribe');
            }, function () {
                setButtonState(false);
                setNotification('error');
            });
        }
    }

    function subscriptionToggle() {
        resetButtonState();
        validateButtonState().then(unsubscribe, subscribe);
    };

    this.appendStyle = function () {
        if (!document.querySelector('style')) {
            var styleTag = document.createElement('style');
            document.getElementsByTagName("head")[0].appendChild(styleTag);
        }

        var styleTag = document.querySelector('style');
        styleTag.innerHTML = styleTag.innerHTML + css.toString();
    };

    this.appendStyle();
    validateButtonState();
    if(!webPushService.getToken() && Notification.permission === 'granted'){
        setTimeout(function(){
                validateButtonState();
        }, 5000);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/services/button.js
// module id = 14
// module chunks = 0